import { app } from '../../core/App';
import { Sounds } from '../../sounds'
import { Driver, Vehicle } from './Vehicle';
import { VehicleFactory } from './VehicleFactory';
import { Level, LevelName, LevelNameValues, LootStage, RampStage } from '../level/levels/level';
import { PlayerController } from './PlayerController';
import { LevelManager } from '../LevelManager';
import { CharacterNameValues } from './Character';
import { MathExtras } from '../../core/utils/MathExtras';
import OnboardingControls from '../../prefabs/OnboardingControls';
import { GameDataHandler } from '../GameDataHandler';
import { RunSettingsHandler } from '../RunSettingsHandler';
import { AIBoss } from './AIBoss';
import { VehicleVillain } from './VehicleVillain';
import { VehicleHero } from './VehicleHero';
import { LevelUtil } from '../level/levels/LevelUtil';
import { ThemeUtil } from '../level/themes/ThemeUtil';
import { Theme } from '../level/themes/theme';
import { LevelFeature } from './../level/LevelFeature';

export class VehicleManager {
  protected scene: Phaser.Scene;
  protected levelManager: LevelManager;

  protected playerVehicleController: PlayerController | undefined;
  protected npcBossController: AIBoss | undefined;
  protected heroVehicle: VehicleHero | undefined;
  protected villainVehicle: VehicleVillain | undefined;
  protected vehicles: Vehicle[];

  constructor(scene: Phaser.Scene, levelManager: LevelManager) {
    this.scene = scene;
    this.levelManager = levelManager;

    this.vehicles = [];
  }

  get HeroVehicle(): VehicleHero | undefined {
    return this.heroVehicle;
  }

  get VillainVehicle(): VehicleVillain | undefined {
    return this.villainVehicle;
  }

  get BlockedZones() {
    return this.levelManager.BlockedZones;
  }

  public init(vehicleFactory: VehicleFactory, level: Level) {
    this.setupVehicles(vehicleFactory, level);
  }

  public start() {
    // for (const taxi of this.taxis) {
    //   taxi.startMoving();
    // }
  }

  public pause() {
    // for (const taxi of this.taxis) {
    //   taxi.stopMoving();
    // }
  }

  public resume() {
    // for (const taxi of this.taxis) {
    //   taxi.startMoving();
    // }
  }

  public end() {
    for (const vehicle of this.vehicles) {
      vehicle.runFinished();
    }
  }

  public startVillain() {
    this.villainVehicle?.startMoving();
    this.villainVehicle?.accelerateX();
  }

  public startHero() {
    this.heroVehicle?.startMoving();
    this.heroVehicle?.accelerateX();
  }

  public stopVillain() {
    this.villainVehicle?.decelerateX(true);
  }

  public stopHero() {
    this.heroVehicle?.decelerateX(true);
  }

  public dropLoot(lootStage: LootStage) {
    this.npcBossController?.dropLoot(lootStage);
  }

  public takeRamp(rampStage: RampStage, feature: LevelFeature) {
    this.npcBossController?.takeRamp(rampStage, feature);
  }

  public startCapturePhase() {
    this.npcBossController?.toggleEvasiveBehaviour(false);
    this.npcBossController?.toggleLootDropping(false);
    this.npcBossController?.toggleMirrorHero(true);
    this.npcBossController?.toggleWeapon(false);
  }

  public prepareCapture(isInFront: boolean, heroTargetYOffset: number, villainTargetYOffset: number) {
    if (this.HeroVehicle && this.VillainVehicle) {
      this.VillainVehicle?.toggleMovementLock(true);
      this.VillainVehicle?.toggleDepthControl(false);
      this.VillainVehicle?.moveToY(LevelUtil.RoadMiddle + villainTargetYOffset, true);

      this.HeroVehicle.toggleMovementLock(true);
      this.HeroVehicle.toggleDepthControl(false);
      this.HeroVehicle.setDepth(this.VillainVehicle.depth + (isInFront ? 1 : -1));
      this.HeroVehicle.moveToY(LevelUtil.RoadMiddle + heroTargetYOffset, true);

      this.heroVehicle?.CharacterSpine.showBelt();
    }
  }

  public fireCapture(heroTargetYOffset: number, villainTargetYOffset: number) {
    if (this.HeroVehicle && this.VillainVehicle) {
      this.HeroVehicle.captureFire();

      // this.HeroVehicle.toggleYControl(false);
      // this.HeroVehicle.y = LevelUtil.RoadMiddle + heroTargetYOffset;
    }
  }

  public registerVehicle(vehicle: Vehicle) {
    // if (vehicle.DriverProfile.driver == Driver.Player) {
    //   this.taxis.push(vehicle);
    // } else if (vehicle.DriverProfile.driver == Driver.Villain) {
    //   this.npcTaxis.push(vehicle);
    //   this.taxis.push(vehicle);
    // } else if (vehicle.DriverProfile.driver == Driver.Civilian) {
    //   this.trafficVehicles.push(vehicle);
    // }

    this.vehicles.push(vehicle);
  }

  // public findNearestVehicleToPoint(frontPointX: number, backPointX: number, vehicleToExclude: Vehicle): Map<number, LaneItem | undefined> {
  //   let nextVehicle: Map<number, LaneItem | undefined> = new Map();

  //   for (const vehicle of this.vehicles) {
  //     if (vehicle == vehicleToExclude) continue;

  //     let laneItem = nextVehicle.get(vehicle.CurrentLane);
  //     let bounds = (vehicle.body as MatterJS.BodyType).bounds;

  //     // Is in front of vehicle?
  //     if (bounds.min.x > frontPointX) {
  //       if (!laneItem || bounds.min.x < laneItem.distance) {
  //         if (!laneItem) laneItem = { classification: ObjectClassification.Vehicle, distance: 0 };
  //         laneItem.classification = ObjectClassification.Vehicle;
  //         laneItem.distance = (vehicle.body as MatterJS.BodyType).bounds.min.x;
  //         nextVehicle.set(vehicle.CurrentLane, laneItem);
  //       }
  //       // Is inside of vehicle?
  //     } else if (MathExtras.getOverlap(backPointX, frontPointX, bounds.min.x, bounds.max.x)) {
  //       if (!laneItem) laneItem = { classification: ObjectClassification.Vehicle, distance: 0 };
  //       laneItem.classification = ObjectClassification.Vehicle;
  //       laneItem.distance = frontPointX;
  //       nextVehicle.set(vehicle.CurrentLane, laneItem);
  //     }
  //   }

  //   return nextVehicle;
  // }

  // public findClosestPassengerInVehicle(vehicle: Vehicle): { closestVehicle: Vehicle; distanceBetween: number } {
  //   let distanceBetween = -1;
  //   let closestVehicle = vehicle;

  //   // for (const taxi of this.taxis) {
  //   //   if (taxi == vehicle) continue;

  //   //   if (taxi.HasPassengers) {
  //   //     let distance = Phaser.Math.Distance.Between(taxi.x, taxi.y, vehicle.x, vehicle.y);
  //   //     if (distanceBetween == -1 || distance < distanceBetween) {
  //   //       distanceBetween = distance;
  //   //       closestVehicle = taxi;
  //   //     }
  //   //   }
  //   // }

  //   return { closestVehicle: closestVehicle, distanceBetween: distanceBetween };
  // }

  protected setupVehicles(vehicleFactory: VehicleFactory, level: Level) {
    let theme = ThemeUtil.getTheme(level.theme);
    let startY = 0;
    let playerIndentX = 0;
    this.setupPlayer(vehicleFactory, level.hero, level, theme, startY, playerIndentX);

    // Show onboarding if level1.
    if (GameDataHandler.showOnboarding(this.scene) && this.playerVehicleController && this.heroVehicle) {
      let onboardingControls = new OnboardingControls(this.scene, this.HeroVehicle?.x, this.heroVehicle?.y);
      this.scene.add.existing(onboardingControls);
      onboardingControls.setTarget(this.playerVehicleController, this.heroVehicle);
      onboardingControls.start();
    }

    this.addVillain(vehicleFactory, level.villain, level, theme, 0, 1200);

    // let possibleSkins: VehicleSkinsValues[] = TaxiSkinsPool.slice();
    // let index = possibleSkins.indexOf(playerSkin);
    // if (index >= 0) possibleSkins.splice(index, 1);

    // for (let i = 0; i < level.taxiDetails.npcTaxis; i++) {
    //   let defaults = level.taxiDetails.taxis[i];
    //   let rand = Phaser.Math.Between(0, possibleSkins.length - 1);
    //   let character = possibleSkins.splice(rand, 1)[0];
    //   let characterData = this.generateCharacterData(Character.upgradePool.slice(), totalUpgradePoints);
    //   this.addAI(vehicleFactory, character, characterData, playerLane, defaults?.startLane ?? i + 1, defaults?.startIndentX ?? 1000);
    // }
  }

  protected setupPlayer(vehicleFactory: VehicleFactory, playerSkin: CharacterNameValues, level: Level, theme: Theme, startY: number, indentX: number) {
    let driverProfile = vehicleFactory.makeHeroProfile(playerSkin);
    let vehicleHandling = level.heroVehicleHandling;

    this.heroVehicle = vehicleFactory.makeHeroVehicle(driverProfile, vehicleHandling, startY, indentX, !theme.isSky);
    this.playerVehicleController = new PlayerController(this.scene, this.heroVehicle);
  }

  protected addVillain(vehicleFactory: VehicleFactory, villainSkin: CharacterNameValues, level: Level, theme: Theme, startY: number, startDistance: number) {
    let driverProfile = vehicleFactory.makeVillainProfile(villainSkin);
    let vehicleHandling = level.villainVehicleHandling;

    this.villainVehicle = vehicleFactory.makeVillainVehicle(driverProfile, vehicleHandling, startY, startDistance, !theme.isSky);
    let aiBoss = new AIBoss(this.scene, this.villainVehicle, this, this.levelManager);
    this.npcBossController = aiBoss;
  }
}
